import { render, staticRenderFns } from "./DocumentItem.vue?vue&type=template&id=6b06c0d5&scoped=true"
import script from "./DocumentItem.vue?vue&type=script&lang=js"
export * from "./DocumentItem.vue?vue&type=script&lang=js"
import style0 from "./DocumentItem.vue?vue&type=style&index=0&id=6b06c0d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b06c0d5",
  null
  
)

export default component.exports